// This is a duplication of the AppAlert modal but for non modal components.
// I didn't want this PR to be too big and I'm not sure how much we'll use this component so I'm leaving it here for now.
// If we want consistent look and behaviour we might want to refactor the AppAlert modal to use this component.

import React, { useState } from 'react'
import { AlertColors, AlertIcon, VariantType } from '../../../AppAlertProvider'
import { cn } from '../../utilities'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '../../../../shad-components/ui/dialog'
import { HelpCenterIcon } from '../../icons/menu'
import { IconType } from '../../icons/types'
import { selectProgramSettings } from '@/storage/program_settings/programSettingsSlice'
import { useSelector } from 'react-redux'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { Button } from '@/common/components/Button.tsx'
import { useTranslation } from 'react-i18next'
import { LogUserActivity } from '@/apis/users/requests.ts'
import { LOG_TYPES } from '@/app/pages/family_application/constants.ts'

interface Props {
  title: string | React.ReactNode
  text: string | React.ReactNode
  variant: VariantType
  children?: React.ReactNode | undefined
  className?: string
  needHelp?: boolean
}

function AppAlertButtonArea({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-center justify-center w-full gap-2">
      {children}
    </div>
  )
}

  function AppAlertComponent(props: Props) {
  const { text, title, variant, children, className, needHelp } = props
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const programSettings = useSelector(selectProgramSettings)
  const application = useSelector(selectFamilyApplication)

  const { t: translate } = useTranslation()

  return (
    <div
      className={cn(
        `bg-white border border-grey-200 rounded-md overflow-hidden pb-6`,
        className
      )}
    >
      <div className="text-center ">
        {/* Banner */}
        <div className={cn(`w-full h-2 mb-6 ${AlertColors.bg[variant]}`)}></div>
        <div className="px-6">
          {/* Icon */}
          <div className="mb-6">
            <AlertIcon variant={variant} />
          </div>

          {/* Title */}
          <div
            className={cn(
              'text-lg font-semibold leading-6 text-gray-900 pt-2 '
            )}
          >
            {title}
          </div>

          {/* Message */}
          <p className="break-words text-center mx-auto pb-12 text-base  text-gray-600 pt-2">
            {text}
          </p>

          {needHelp &&
            <Dialog
              open={isDialogOpen}
              onOpenChange={(open) => {
                setIsDialogOpen(open);
                if (open) {
                  LogUserActivity({
                    log_type: LOG_TYPES.VIEW_PAGE,
                    suffix_text: 'Viewed Need Help? Option',
                  });
                }
              }}
            >
              <DialogTrigger className="py-1 w-full hover:text-gray-950">
                <div className="block w-full text-left hover:bg-gray-100 px-4 py-2  text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900">
                  <HelpCenterIcon
                    className="mr-5"
                    type={IconType.Outline}
                    aria-hidden="true"
                  />
                  {translate('need_help')}
                </div>
              </DialogTrigger>
              <DialogContent className="sm:max-w-md">
                <DialogHeader>
                  <DialogTitle>{translate('need_help')}</DialogTitle>
                  <DialogDescription className="text-gray-600 text-center"></DialogDescription>
                </DialogHeader>
                <div className="p-4 text-gray-800">
                  <div className="mt-2 mb-4">
                    {translate('need_help_info.need_assistance')}{' '}
                    {programSettings.name} {translate('need_help_info.by_phone')}
                    <div className="font-medium">+1 (985) 800-3950</div>
                  </div>
                  <div className="mt-2 mb-4">
                    {translate('need_help_info.or_email')}
                    <div className="font-medium">
                      {/*support@ufascholarship.com*/}
                      support@acescholarships.org
                    </div>
                  </div>

                  <div className="mt-2 mb-4">
                    {translate('need_help_info.provide_id')}
                    <div className="font-medium">
                      {application.applicant_id}
                    </div>
                  </div>
                  <Button onClick={() =>   setIsDialogOpen(false)}>
                    {translate('need_help_info.go_it')}
                  </Button>
                </div>
              </DialogContent>
            </Dialog>
          }
          {/* Buttons */}
          <AppAlertButtonArea>{children}</AppAlertButtonArea>
        </div>
      </div>
    </div>
  )
}

export default AppAlertComponent
